import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import ZoneComponent from '../components/zone.component';
import { zones } from '../../../../../redux/zones/action';
import { selectZonesQueryItems } from '../../../../../redux/zones/selector';
import PageLoader from '../../../../../components/PageLoader';

const ManagementZone = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const zoneQuery = useSelector(selectZonesQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [
        selectedZone,
        setSelectedZone
    ] = useState<any>([])


    const fetchRouteById = () => {
        dispatch(zones.query({
            url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/zones/query`, entity: 'zones', jsonData: {

                Records: [
                    {
                        Id: parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(()=>{
            setIsLoading(false)
          })
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedZone({ ...selectedZone, [field]: event });
    }

    useEffect(() => {
            if (parmas?.id > 0) {
                fetchRouteById()
                setIsLoading(false)
            }else {
                setIsLoading(false)
            }
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                setSelectedZone(zoneQuery?.result?.items)
            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            dispatch(zones.update({
                url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/zones`, entity: 'zones', jsonData: {

                    Records: [
                        selectedZone
                    ]

                }
            })).then(()=>{
                back()
              })

        } else {
            dispatch(zones.create({
                url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/zones`, entity: 'zones', jsonData: {

                    Records: [
                        selectedZone
                    ]

                }
            })).then(()=>{
                back()
              })
        }

    }

    const back = () => {
        navigate('/management/route-management/zones')
    }

    return (
        <>
           {isLoading ? <PageLoader /> : 
            <ZoneComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedZone={selectedZone}
                back={back}
                handleFormSubmit={handleFormSubmit}
            />
        }
        </>
    )

}

export default ManagementZone;